










































import { Component, Prop, Vue } from "vue-property-decorator";
import ItemData from "../model/ItemData";

@Component
export default class MemoEditor extends Vue {
  memo: ItemData = new ItemData(-1, 0);

  created(): void {
    this.memo = this.$store.state.transMemo;
  }

  closeWin() {
    this.$store.state.isShow = false;
  }
  saveNew() {
    // 校验
    if (
      this.memo &&
      this.memo.categoryId > -1 &&
      this.memo.title.trim().length > 0 &&
      this.memo.content.trim().length > 0
    ) {
      if (this.memo.id <= -1) {
        // 新建
        this.$store.state.aHelper.add(this.memo);
      } else {
        // 修改
        this.$store.state.aHelper.edit(this.memo);
      }
      this.$store.state.isShow = false;
    } else {
      alert("对不起，输入错误~~！");
    }
  }
}
